import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchCodeUrl } from '@/constants/urls';
import { closeRequestWorkspace } from '../actions';
import WorkspaceRequestWizardActions from '../components/WorkspaceRequestWizardActions';
import WorkspacePanel from '../components/WorkspacePanel';

export default {
  ...tabTemplate('workspace', WorkspacePanel, matchCodeUrl(['workspace']), WorkspaceRequestWizardActions),
  ...tabCloser('closeWorkspaceTab', closeRequestWorkspace),
  ...tabIcons('cube'),
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  order: 8000,
};
